import * as Immutable from 'immutable';
import {createAction} from 'redux-actions';
import { actionTypes as system } from '../System';
import {handleActions} from '../../Utility/HandleActions';

//action types
const SAGA_LOAD_DATA_START = "DBM/DATA/CURRENCY_PAIR/SAGA_LOAD_DATA_START";
const SAGA_LOAD_DATA_SUCCESS = "DBM/DATA/CURRENCY_PAIR/SAGA_LOAD_DATA_SUCCESS";

const sagaLoadDataStart = createAction(SAGA_LOAD_DATA_START);
const sagaLoadDataSuccess = createAction(SAGA_LOAD_DATA_SUCCESS);

export const actionTypes = {
    SAGA_LOAD_DATA_START,
    SAGA_LOAD_DATA_SUCCESS
};

export const actions = {
    sagaLoadDataStart,
    sagaLoadDataSuccess
};

export const reducer = handleActions({
    [system.INIT]: () => {
        return (state) => {
            return state.setIn(['data', 'currencyPair'], Immutable.fromJS({}));
        }
    },
    [SAGA_LOAD_DATA_START]: () => {
        return (state) => {
            return state.setIn(['data', 'currencyPair'], Immutable.fromJS({}));
        }
    },
    [SAGA_LOAD_DATA_SUCCESS]: (data) => {
        return (state) => {
            return state.setIn(['data', 'currencyPair'], Immutable.fromJS(data));
        }
    }

});

const getData = (state) => state.getIn(['data', 'currencyPair']).toJS();

export const selectors = {
    getData
};
